<section class="subhero">
    <div class="container">
        <div class="row">
            <h2>Entrevista sobre o projeto</h2>
        </div>
    </div>
</section>
<div class="container content">
    <div class="row">
        <div class="col">
            <h3 class="paragraph_style_5">Entrevista com o Prof. Menna-Barreto<br/></h3>
            <div class="youtube row">
                <div class="col-md-6">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/vjXD69-TAu0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                </div>
                <div class="col-md-6">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/5jLQ4A_xvxY" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </div>
</div>
